module.exports = __webpack_public_path__ + "img/11.b80ce1c3.jpeg";